import { render, staticRenderFns } from "./WebPagesEditorActions.vue?vue&type=template&id=641faf69&"
import script from "./WebPagesEditorActions.vue?vue&type=script&lang=js&"
export * from "./WebPagesEditorActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports